import { createAuthClient as betterAuthCreateAuthClient } from 'better-auth/react';
import { adminClient, organizationClient } from 'better-auth/client/plugins';
import { ClientOptions } from 'better-auth/client';
import { devLoginClient, discordActivityLoginClient } from '@tofu/utils/auth';

export const createAuthClient = (platformApiUrl: string) => {
  const authClientOptions = {
    baseURL: platformApiUrl,
    basePath: '/auth2',
    fetchOptions: { credentials: 'include' },
    plugins: [adminClient(), organizationClient(), devLoginClient(), discordActivityLoginClient()],
  } satisfies ClientOptions;
  return betterAuthCreateAuthClient(authClientOptions);
};

export type AuthClient = ReturnType<typeof createAuthClient>;
